import React from 'react'
import { Layout } from 'antd'
import { injectIntl } from 'react-intl'
import SuperEgoLogo from 'components/SuperEgoLogo'
import ShowForScreenWidth from 'components/ShowForScreenWidth'
import LegalInfoModal from 'components/LegalInfoModal'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import ProfileSnippet from './ProfileSnippet'
import Header from './Header'
import MenuLeft from './MenuLeft'
import style from './style.module.scss'

const { Sider, Content, Footer } = Layout
const currentYear = new Date().getFullYear()

class MainLayout extends React.Component {
  state = {
    collapsed: false,
  }

  toggleSlider = () => this.setState(prevState => ({ collapsed: !prevState.collapsed }))

  render() {
    return (
      <Layout className={style.mainLayout}>
        <ShowForScreenWidth min={900}>
          <Sider
            width={235}
            theme="light"
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.toggleSlider}
            className={style.slider}
          >
            <div className={style.logoWrapper}>
              <SuperEgoLogo collapsed={this.state.collapsed} />
            </div>
            <ProfileSnippet collapsed={this.state.collapsed} />
            <MenuLeft />
          </Sider>
        </ShowForScreenWidth>
        <Layout>
          <Header />
          <Content>
            <div className={style.contentWrapper}>
              {this.props.children}
            </div>
          </Content>
          <Footer className={style.footer}>
            {currentYear} © Super Ego.<LegalInfoModal />
          </Footer>
        </Layout>
      </Layout>
    )
  }
}

export default errorBoundaryEnhancer(injectIntl(MainLayout))
